import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from './../../helpers/BaseError';

// models
import { NotifyDeveloperRequestModel } from '../../models/notify-developer.model';

// API
import API from '../../services/api';

export default function useNotifyDeveloper() {
    return useMutation<
        AxiosResponse<string>,
        BaseError,
        NotifyDeveloperRequestModel
    >({ mutationFn: API.notifyDeveloper });
}
